import { csrfToken } from '@rails/ujs'

export const processAiRequest = async (
  model,
  actionType,
  data = null,
  signal,
  jobId = null,
  basePath = '/ai'
) => {
  const payload = {
    model,
    ai_action: actionType,
    job_id: jobId,
  }

  if (data) {
    payload.data = data
  }

  try {
    const response = await fetch(`${basePath}/process`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken(),
      },
      body: JSON.stringify(payload),
      credentials: 'same-origin',
      signal,
    })

    if (!response.ok) {
      let errorMessage
      const contentType = response.headers.get('content-type')

      if (contentType && contentType.includes('application/json')) {
        try {
          const errorData = await response.json()
          errorMessage =
            errorData.error ||
            `AI request failed with status ${response.status}`
        } catch (jsonError) {
          errorMessage = `Failed to parse error response: ${jsonError.message}`
        }
      }

      throw new Error(errorMessage)
    }

    return await response.json()
  } catch (error) {
    throw error
  }
}
